import * as React from "react"

function Icon1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      {...props}
    >
      <title>{"ICON 1"}</title>
      <g fill="none" fillRule="evenodd">
        <g strokeWidth={2}>
          <path
            d="M41 4c6.075 0 11 4.925 11 11s-4.925 11-11 11c-1.8 0-3.5-.432-5-1.2V23a4 4 0 00-4-4h0l-1.25.001c-.484-1.24-.75-2.59-.75-4.001 0-6.075 4.925-11 11-11z"
            stroke="#E3E833"
          />
          <g transform="translate(9 19)" stroke="#FFF">
            <rect width={27} height={37} rx={4} />
            <circle transform="matrix(1 0 0 -1 0 62)" cx={14} cy={31} r={1} />
          </g>
          <path stroke="#E3E833" strokeLinecap="round" d="M41 9v6h5" />
        </g>
      </g>
    </svg>
  )
}

export default Icon1
